"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function GoogleChrome16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM6.90518 13.9003L8.00235 12H8C6.60308 12 5.3734 11.2839 4.65802 10.1988L2.13234 6.74086C2.04563 7.14688 2 7.56811 2 8C2 10.9398 4.11426 13.3858 6.90518 13.9003ZM3.05064 4.60727C4.13208 3.03267 5.94545 2 8 2C9.777 2 11.3736 2.7725 12.4722 4H8C6.36876 4 4.96557 4.97646 4.34308 6.37676L3.05064 4.60727ZM13.6586 6H11.4649C11.8052 6.58835 12 7.27143 12 8C12 8.7283 11.8054 9.41114 11.4653 9.99934L11.4664 10L9.22989 13.8738C11.9537 13.3064 14 10.8922 14 8C14 7.29873 13.8797 6.62556 13.6586 6ZM10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z", fill: "#383F49" }));
}
function GoogleChrome16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(GoogleChrome16Svg, Object.assign({}, svgProps)));
}
exports.default = GoogleChrome16;
//# sourceMappingURL=GoogleChrome16.js.map